import React from 'react';
import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DateTimePicker } from '@mui/x-date-pickers';
import { getBorderColor, getBorderColorActive } from '../../../theme/Components';

const CustomDateTimePicker = styled(({ MenuProps, ...props }) => <DateTimePicker {...props} />)(
  ({ theme }) => ({
    '& fieldset': {
      borderColor: getBorderColor(theme)
    },
    '&:hover fieldset': {
      borderColor: getBorderColorActive(theme)
    }
  })
);

export default CustomDateTimePicker;
